import { Box, Button, Card, Grid, Typography, Link, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux";
import { ReelWithCategory } from "../../../interfaces/tell_me_watch/reel.types";
import { AppState } from "../../../store/store";
import { getReelCategoryNameById } from "../../../utility/getCategoryNames";
import ReelsDeleteDialog from "./Reels_Delete";
import ReelsUpdateDialog from "./Reels_Update";

const AllReelsComponent = () => {
    const reels = useSelector((appstate: AppState) => appstate.reels);
    const reelsCategories = useSelector((appstate: AppState) => appstate.reelsCategories);
    const [reelsResults, setReelsResults] = useState<Array<ReelWithCategory>>(reels);
    const [searchCategory, setSearchCategory] = useState("");
    const [searchVideoId, setSearchVideoId] = useState("");

    const [openReelUpdateDialog, setOpenReelUpdateDialog] = useState(false);
    const [openReelDeleteDialog, setOpenReelDeleteDialog] = useState(false);
    const [selectedReel, setSelectedReel] = useState<ReelWithCategory | null>();

    // Update UI According to reels state changes
    useEffect(() => {
        setReelsResults(reels);
    }, [reels]);
    
    // Category Id Search
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            handleCategorySearch(searchCategory)
        }, 600);
        return () => clearTimeout(delayDebounceFn);
    }, [searchCategory])

    // Video Id Search
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            handleVideoIdSearch(searchVideoId)
        }, 600);
        return () => clearTimeout(delayDebounceFn);
    }, [searchVideoId])

    const handleVideoIdSearch = (value: string) => {
        console.log("Handle Search Triggered");
        if (value === "") {
            setReelsResults(reels);
            return;
        }
        const results: ReelWithCategory[] = [];
        reels.map((reel) => {
            if(reel.id.toLowerCase().includes(value.toLowerCase())){
                results.push(reel);
            }
        });
        setReelsResults(results);
    }

    const handleCategorySearch = (value: string) => {
        console.log("Handle Search Triggered");
        if (value === "") {
            setReelsResults(reels);
            return;
        }
        const results: ReelWithCategory[] = [];
        reels.map((reel) => {
            reel.categoryIds.forEach((category) => {
                const categoryName = getReelCategoryNameById(reelsCategories, category);
                if (!results.includes(reel) && categoryName.toLowerCase().includes(value.toLowerCase())) {
                    results.push(reel);
                }
            });
        });
        setReelsResults(results);
    }

    const handleUpdate = (reel: ReelWithCategory) => {
        setSelectedReel(reel);
        setOpenReelUpdateDialog(true);
    }
    const handleUpdateClose = () => {
        setSelectedReel(null);
        setOpenReelUpdateDialog(false);
    }

    const handleDelete = (reel: ReelWithCategory) => {
        setSelectedReel(reel);
        setOpenReelDeleteDialog(true);
    }
    const handleDeleteClose = () => {
        setSelectedReel(null);
        setOpenReelDeleteDialog(false);
    }

    return (
        <div>

            <Grid container direction="row" justifyContent="center">
                <Typography variant="h3">
                    All Reels
                </Typography>

                <TextField style={{ width: 250, marginLeft: 120 }}
                    id="category_search"
                    label="Search Category Name"
                    value={searchCategory}
                    variant="outlined"
                    onChange={(val) => setSearchCategory(val.target.value)} />

                <TextField style={{ width: 250, marginLeft: 120 }}
                    id="video_id_search"
                    label="Search Video Id"
                    value={searchVideoId}
                    variant="outlined"
                    onChange={(val) => setSearchVideoId(val.target.value)} />
            </Grid>


            <Box height={60} />

            <Grid container >
                {
                    reelsResults.map(reel => {
                        return (
                            <Grid item id={reel.id} xs={4}>
                                <Card id={reel.id} style={{ margin: 15, padding: 25, }}>
                                    <Typography>
                                        Video Id: {reel.id}
                                    </Typography>
                                    <Typography>
                                        Categories: {reel.categoryIds.map((e) => getReelCategoryNameById(reelsCategories, e)).join(", ")}
                                    </Typography>
                                    <img src={reel.previewImageUrl} style={{ width: 100, margin: 15 }} />
                                    <Box margin={2}>
                                        <Link target="_blank" color="inherit" href={reel.previewImageUrl} style={{ margin: 10, color: "rebeccapurple", fontWeight: "bolder", }}>
                                            Preview
                                        </Link>
                                        <Link target="_blank" color="inherit" href={reel.videoUrl} style={{ margin: 10, color: "green", fontWeight: "bolder", }}>
                                            Video
                                        </Link>
                                        <Link target="_blank" color="inherit" href={reel.shareVideoUrl} style={{ margin: 10, color: "blue", fontWeight: "bolder", }}>
                                            Share Video
                                        </Link>
                                    </Box>
                                    <Button style={{ margin: 10 }} variant="outlined" onClick={() => handleUpdate(reel)}>
                                        Update
                                    </Button>
                                    <Button style={{ margin: 10 }} variant="outlined" onClick={() => handleDelete(reel)}>
                                        Delete
                                    </Button>
                                </Card>
                            </Grid>
                        )
                    })
                }
            </Grid>
            {
                selectedReel ?
                    <>
                        <ReelsUpdateDialog
                            handleClose={handleUpdateClose}
                            open={openReelUpdateDialog}
                            reel={selectedReel}
                        />
                        <ReelsDeleteDialog
                            handleClose={handleDeleteClose}
                            open={openReelDeleteDialog}
                            reel={selectedReel}
                        />
                    </> :
                    <></>

            }

        </div>
    )
}

export default AllReelsComponent;